// Vendor Libs
import {cloneDeep} from 'lodash';

const initialState = {
    fetched: false,
    fetching: false,
    error: null,
    response: null,
};

function getInitialState() {
    return cloneDeep(initialState);
}

const actions = {
    DELETE_DATA_MODIFIER: () => ({...getInitialState(), fetching: true}),

    DELETE_DATA_FULFILLED: (state, {response}) => ({
        ...state,
        error: null,
        fetched: true,
        fetching: false,
        response,
    }),

    DELETE_DATA_REJECTED: (state, {error}) => ({
        ...state,
        fetched: true,
        fetching: false,
        error,
    }),

    DELETE_DATA_RESET: () => getInitialState(),
};

const reducer = (state = initialState, action) => (actions[action.type] ? actions[action.type](state, action) : state);

export default reducer;
